export const ANALYTICS_CONSENT_KEY = 'ertzyx-cookie-consent';
export const ANALYTICS_CONSENT_EVENT = 'ertzyx-consent-change';
// Dispatched by any "Cookie Settings" control (footer, settings page) to reopen
// the consent banner for review, regardless of whether a choice was already stored.
export const ANALYTICS_CONSENT_SETTINGS_EVENT = 'ertzyx-open-cookie-settings';

export type AnalyticsConsentValue = 'accepted' | 'declined';

export function getStoredAnalyticsConsent(): AnalyticsConsentValue | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  return value === 'accepted' || value === 'declined' ? value : null;
}

export function hasAnalyticsConsent(): boolean {
  return getStoredAnalyticsConsent() === 'accepted';
}

export function setAnalyticsConsent(value: AnalyticsConsentValue): void {
  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  window.dispatchEvent(new Event(ANALYTICS_CONSENT_EVENT));
}

export function openAnalyticsConsentSettings(): void {
  window.dispatchEvent(new Event(ANALYTICS_CONSENT_SETTINGS_EVENT));
}
